export enum LandingAction {
  VERIFY,
  UNSUBSCRIBE,
  UNSUBSCRIBE_SURVEYS,
  ADD_COUPON,
  REORDER,
  ACTIVITY,
  PRINT_RECEIPT,
}
